export const getContactUsIsPosting = state => state.contactUsReducer.isPosting;
export const getContactUsPostSuccess = state => state.contactUsReducer.postSuccess;
export const getContactUsError = state => state.contactUsReducer.error;
